import React from 'react';
import EmisorSuggestionsList from './EmisorSuggestionsList';
import EmisorSelected from './EmisorSelected';


const EmisorSuggestions = (props) => {

  const handleOnSelect = (item) => {
    props.onSelect(item);
  }

  const { autoFocus, data = {} } = props;

  return (
    <>
      { !data.rfc && (
          <div>
            <EmisorSuggestionsList
              autoFocus={ autoFocus }
              onSelect={ handleOnSelect }
            />
          </div>
        )
      }

      { !!data.rfc && (
          <EmisorSelected data={ data } />
        )
      }
    </>
  );
}

export default EmisorSuggestions;